(() => {
  if (window.kivivoCommerceLoaded) return;
  window.kivivoCommerceLoaded = true;

  function initializeProducts(scope = document) {
    const sections = [...scope.querySelectorAll('[data-product-section]')];
    if (scope.matches?.('[data-product-section]')) sections.unshift(scope);
    sections.forEach((section) => {
      if (section.dataset.commerceReady) return;
      section.dataset.commerceReady = 'true';
      const gallery = section.querySelector('[data-gallery]');
      const panels = [...section.querySelectorAll('[data-media-panel]')];
      const thumbnails = [...section.querySelectorAll('[data-media-target]')];
      const select = section.querySelector('[data-variant-select]');

      function showMedia(id) {
        const active = panels.find((panel) => panel.dataset.mediaPanel === String(id));
        if (!active) return;
        panels.forEach((panel) => {
          panel.hidden = panel !== active;
          if (panel !== active) panel.querySelectorAll('video').forEach((video) => video.pause());
        });
        thumbnails.forEach((thumbnail) => {
          if (thumbnail.dataset.mediaTarget === String(id)) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
      }

      if (panels.length) showMedia(gallery.dataset.selectedMedia || panels[0].dataset.mediaPanel);
      thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', (event) => {
        event.preventDefault();
        showMedia(thumbnail.dataset.mediaTarget);
      }));

      function updateVariant(updateUrl) {
        const option = select?.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        const price = section.querySelector('[data-product-price]');
        const comparePrice = section.querySelector('[data-product-compare]');
        const button = section.querySelector('[data-add-to-cart]');
        const availability = section.querySelector('[data-availability]');
        const quantity = section.querySelector('[data-product-quantity]');
        price.textContent = option.dataset.price;
        comparePrice.textContent = option.dataset.comparePrice;
        comparePrice.hidden = !option.dataset.comparePrice;
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
        availability.textContent = available ? 'Available to order' : 'This option is currently sold out.';
        const minimum = Number(option.dataset.min) || 1;
        const step = Number(option.dataset.step) || 1;
        quantity.min = String(minimum);
        quantity.step = String(step);
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        let nextQuantity = Math.max(minimum, Number(quantity.value) || minimum);
        nextQuantity = minimum + Math.ceil((nextQuantity - minimum) / step) * step;
        if (quantity.max) nextQuantity = Math.min(nextQuantity, Number(quantity.max));
        quantity.value = String(nextQuantity);
        if (option.dataset.mediaId) showMedia(option.dataset.mediaId);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      }

      select?.addEventListener('change', () => updateVariant(true));
      updateVariant(false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeProducts());
  else initializeProducts();
  document.addEventListener('shopify:section:load', (event) => initializeProducts(event.target));
})();
